import { useProperty } from '@vibesites/runtime/react';

function hasText(value: unknown): boolean {
  return String(value ?? '').trim().length > 0;
}

/**
 * True when the property has BOTH ApartmentSync (Repli360 / RRAC) IDs —
 * the JavaScript ID (script URL token) and the Config ID (site
 * identifier). Only one populated is a half-configured state with no
 * working map. These are custom `text` fields, so they're read off
 * `useProperty()` rather than the strongly-typed `usePropertyField`.
 */
export function useHasApartmentSyncIds(): boolean {
  const property = useProperty() as Record<string, unknown> | null | undefined;
  return (
    hasText(property?.custom_apartmentsync_javascript_id) &&
    hasText(property?.custom_apartmentsync_config_id)
  );
}
